<template>
    <div class="title" :class="{[fontSize]:true}">
        <span class="tag"></span>
        {{name}}
    </div>
</template>

<script>
    export default {
        name: "barTitle",
        props:['name','fontSize']
    }
</script>

<style scoped lang="less">
.title{
    display: flex;
    align-items: center;
    color: #666666;
    font-weight: bold;}
    .tag{
        display: inline-block;
        height: 15px;
        width: 4px;
        margin-right: 10px;
        border-radius: 5px;
        background: #00e2cb;
    }

    .h1{
        font-size: 15px;
    }
</style>